export const assistant = {
routeTitle: "Betriebsassistent",
routeSubtitle: "Betriebsintelligenz für Ihre Anlagen",
inputModeText: "Text zuerst",
widget: {
showLess: "Weniger anzeigen",
showMore: "Mehr anzeigen",
openAssistant: "Assistent öffnen",
live: "Live",
assistantLabel: "Assistent",
headerSubtitle: "Fragen, prüfen, planen, neu zuweisen oder Arbeit erstellen, ohne diesen Bildschirm zu verlassen.",
newConversation: "Neues Gespräch",
close: "Schließen",
newThread: "Neuer Thread",
loadingConversation: "Gespräch wird geladen…",
emptyTitle: "Ständiger Betriebs-Chat",
emptyBody: "Beginnen Sie mit einer natürlichen Anweisung. Der Assistent kann Fragen beantworten, Maßnahmen vorschlagen und auf Ihre Bestätigung warten, wenn eine Änderung wichtig ist.",
actorYou: "Sie",
actorAssistant: "Assistent",
usedWorkspaceData: "Verwendete Arbeitsbereichsdaten",
recommendationFallbackTitle: "Empfehlung",
dictationInserting: "Transkript wird eingefügt…",
dictationFinishing: "Diktat wird beendet…",
dictationHeard: "Gehört: {{transcript}}",
dictationListening: "Zuhören…",
messageInputLabel: "Nachricht an den Assistenten",
messagePlaceholder: "Stellen Sie eine Frage oder sagen Sie dem Assistenten, was er tun soll",
messagePlaceholderShort: "Fragen oder Auftrag eingeben …",
stopDictation: "Diktat beenden",
dictateMessage: "Nachricht diktieren",
sendingMessage: "Nachricht wird gesendet",
sendMessage: "Nachricht senden",
sending: "Wird gesendet…",
send: "Senden",
composerHintPhone: "Tippen Sie zum Diktieren auf das Mikrofon.",
composerHintDesktop: "Tippen Sie zum Diktieren auf das Mikrofon. „Enter“ sendet auf Hardware-Tastaturen; „Umschalt + Eingabetaste“ fügt eine neue Zeile hinzu.",
},
conversation: {
newSession: "Neue Sitzung",
inputModeLabel: "Eingabemodus: {{mode}}",
modeHint: "Sprachfähige Transkript-Pipeline; Text ist jetzt aktiv.",
retry: "Wiederholen",
loadingHistory: "Assistentenverlauf wird geladen...",
emptyTitle: "Operativer Copilot",
emptyBody: "Fragen Sie nach Checklistenentwürfen, Inspektionsplanung, Arbeitsauftragserstellung, Arbeitsstatus, Neuzuweisung, Risikoerklärung oder Empfehlungen für den nächsten Schritt.",
actorYou: "Sie",
actorAssistant: "Assistent",
messagePlaceholder: "Bitten Sie den Assistenten, etwas zu erstellen, zu erklären, zu prüfen, zu empfehlen oder neu zuzuweisen",
},
quickPrompts: {
attention: "Was erfordert gerade meine Aufmerksamkeit?",
inspectionTemplates: "Wo verwalte ich Checklisten?",
requestsTriage: "Welche Anfragen müssen gesichtet werden?",
overdueJobs: "Überfällige Aufträge anzeigen",
assetNextStep: "Was sollte ich als Nächstes mit dieser Anlage tun?",
assetOverdueInspections: "Sind für diese Anlage Inspektionen überfällig?",
assetRiskSummary: "Risiken und offene Arbeit an dieser Anlage zusammenfassen",
scheduleNextInspection: "Nächste Inspektion planen",
assetTopNextStep: "Wichtigsten nächsten Schritt für diese Anlage empfehlen",
assetOpenJobsFirst: "Welche offenen Aufträge sollte ich zuerst prüfen?",
shouldScheduleInspection: "Sollte ich eine Inspektion planen?",
requestSummarize: "Diese Anfrage zusammenfassen und eine Antwort vorschlagen",
requestToJob: "Diese Anfrage in einen Auftrag umwandeln",
requestMissingInfo: "Welche Informationen fehlen noch, um mit der Arbeit zu beginnen?",
requestOwner: "Wer sollte für diese Anfrage zuständig sein?",
requestFastestPath: "Wie lässt sich diese Anfrage am schnellsten umwandeln?",
requestDraftResponse: "Professionelle Antwort an die anfragende Person entwerfen",
requestJobOrInspection: "Sollte daraus ein Auftrag oder eine Inspektion werden?",
inspectionFailedFindings: "Nicht bestandene Befunde zusammenfassen und Folgeaufträge vorschlagen",
inspectionMissingEvidence: "Welche Nachweise fehlen in dieser Inspektion?",
inspectionHighestRisk: "Nicht bestandene Punkte mit dem höchsten Risiko erklären",
inspectionJobsFromUrgent: "Aufträge aus dringenden Befunden erstellen",
jobBlocking: "Was verhindert den Abschluss dieses Auftrags?",
jobNextUpdate: "Nächstes Update vorschlagen, das ich posten sollte",
jobWhoElse: "Wer sollte noch an diesem Auftrag beteiligt sein?",
jobFollowUp: "Welche Folgearbeiten könnten nötig sein?",
jobNextStepToClose: "Nächsten Schritt zum Abschluss dieses Auftrags empfehlen",
jobDraftCompletionNote: "Abschlussnotiz entwerfen",
jobCreateFollowUp: "Sollte ich einen Folgeauftrag anlegen?",
templateImprove: "Wie kann ich diese Checkliste verbessern?",
templateMissingChecks: "Welche Prüfpunkte fehlen für diesen Anlagentyp?",
templateWeekly: "Praxistaugliche wöchentliche Checkliste erstellen",
templateWhereManage: "Wo verwalte ich Checklisten in der App?",
},
  card: {
    edit: 'Bearbeiten',
    doneEditing: 'Fertig',
    editHint: 'Ändern Sie diese Angaben vor dem Bestätigen.',
    confirming: 'Wird bestätigt…',
    dismiss: 'Verwerfen',
    working: 'Wird ausgeführt…',
    undo: 'Rückgängig',
    undoing: 'Wird rückgängig gemacht…',
    undone: 'Rückgängig gemacht',
    undoHint: 'Sie können dies 10 Minuten lang rückgängig machen.',
    edited: 'Bearbeitet',
    fields: {
      name: 'Name',
      description: 'Beschreibung',
      placeType: 'Art des Ortes',
      address: 'Adresse',
      externalId: 'Referenz',
      code: 'Kürzel',
      scheduledDate: 'Fällig (Datum und Uhrzeit)',
      notes: 'Notizen',
      title: 'Titel',
      dueDate: 'Fällig (Datum und Uhrzeit)',
      estimatedCost: 'Schätzung',
      note: 'Update',
      responseText: 'Antwort',
    },
  },
  chart: {
    summary_one: '{{title}}: {{from}}',
    summary_other: '{{title}}: von {{from}} auf {{to}}, {{count}} Werte',
  },
  context: {
    selectedAssets_one: "Frage zu {{count}} ausgewählten Anlage",
    selectedAssets_other: "Frage zu {{count}} ausgewählten Anlagen",
    leaveOut: "Auswahl weglassen",
  },
  memory: {
    title: "Was sich der Assistent merkt",
    intro: "Vorgaben für den ganzen Arbeitsbereich, etwa wie Sie Dinge nennen oder wer eine bestimmte Art von Auftrag meist bekommt. Der Assistent hält sich beim Antworten daran. Alle im Arbeitsbereich können sie sehen.",
    empty: "Noch nichts. Fügen Sie hier etwas hinzu oder bitten Sie den Assistenten, z. B. „Merke dir, dass Gassicherheitsaufträge an Northside Heating gehen“.",
    addPlaceholder: "Etwas, das sich der Assistent merken soll",
    add: "Hinzufügen",
    edit: "Bearbeiten",
    save: "Speichern",
    cancel: "Abbrechen",
    forget: "Vergessen",
    viaAssistant: "Über den Assistenten hinzugefügt",
    added: "Von jemandem im Arbeitsbereich hinzugefügt",
    full: "Der Assistent merkt sich {{max}} Dinge, mehr geht nicht. Vergessen Sie eines, um ein neues hinzuzufügen.",
    saveFailed: "Das wurde nicht gespeichert. Sie können nur ändern, was Sie selbst hinzugefügt haben, außer Sie sind Admin des Arbeitsbereichs.",
  },
  offline: {
    waiting: "Sie sind offline. Dies wird gesendet, sobald Sie wieder online sind.",
    sending: "Wieder online. Wird gesendet…",
    fromGuide: "Bis dahin hilft vielleicht die App-Anleitung:",
    discard: "Nicht senden",
    photoNeedsConnection: "Ein Foto braucht eine Verbindung. Entfernen Sie es, damit die Frage gesendet wird, sobald Sie online sind, oder versuchen Sie es dann erneut.",
    queueFull: "Es warten schon 10 Fragen. Warten Sie, bis Sie wieder online sind.",
  },
  stream: {
    thinking: "Wird bearbeitet …",
    lookingUp_one: "Daten werden abgerufen ({{count}} bisher) …",
    lookingUp_other: "Daten werden abgerufen ({{count}} bisher) …",
  },
  voice: {
    readAloud: "Antworten vorlesen",
    stopReading: "Antworten nicht mehr vorlesen",
    readingAloud: "Antworten werden vorgelesen.",
    handsFree: "Freihändig",
    handsFreeOn: "Freihändig: Nach jeder Antwort hört er auf Ihre nächste Frage.",
  },
  briefing: {
    title: 'Diese Woche',
    stopSuggesting: 'Das nicht mehr vorschlagen',
    hideWeek: 'Bis nächste Woche ausblenden',
    turnOff: 'Wochenüberblick ausschalten',
    settingsTitle: 'Ihr Wochenüberblick',
    settingsIntro: 'Eine kurze Zusammenfassung Ihrer Woche und einige vorgeschlagene Fragen oben im Assistenten. Das ist Ihre eigene Einstellung.',
    on: 'Ein',
    off: 'Aus',
    suggestionsOff_one: '{{count}} Art von Vorschlägen ist ausgeschaltet.',
    suggestionsOff_other: '{{count}} Arten von Vorschlägen sind ausgeschaltet.',
    suggestionsBackOn: 'Vorschläge wieder einschalten',
  },
  photo: {
    add: "Foto hinzufügen",
    replace: "Foto ersetzen",
    remove: "Foto entfernen",
    attached: "Foto angehängt. Der Assistent liest es einmal und speichert es nicht.",
    addTitle: "Foto hinzufügen",
    addBody: "Nehmen Sie ein Foto auf oder wählen Sie eines aus. Der Assistent liest Typenschilder, Messwerte und Schäden.",
    take: "Foto aufnehmen",
    choose: "Foto auswählen",
    cancel: "Abbrechen",
    permissionTitle: "Berechtigung erforderlich",
    cameraPermissionBody: "Erlauben Sie den Kamerazugriff in den Einstellungen, um ein Foto für den Assistenten aufzunehmen.",
    libraryPermissionBody: "Erlauben Sie den Fotozugriff in den Einstellungen, um ein Foto für den Assistenten auszuwählen.",
    failedTitle: "Foto nicht hinzugefügt",
    failedBody: "Dieses Foto konnte nicht geöffnet werden. Versuchen Sie ein anderes.",
    defaultMessage: "Was zeigt dieses Foto?",
  },
  activity: {
    title: 'Assistent-Aktivität',
    subtitleAdmin: 'Alle Änderungen über den Assistenten in diesem Workspace',
    subtitleMember: 'Ihre Änderungen über den Assistenten',
    policyTitle: 'Wer Änderungen über den Assistenten vornehmen darf',
    policyIntroAdmin: 'Jede Person behält ihre eigenen Rechte: Der Assistent kann nur tun, was die Person in der App tun dürfte.',
    policy: {
      everyone: 'Alle',
      admins: 'Inhaber und Admins',
      nobody: 'Niemand',
    },
    policyHelp: {
      everyone: 'Mitglieder können vom Assistenten vorbereitete Änderungen im Rahmen ihrer Rechte bestätigen.',
      admins: 'Mitglieder können Fragen stellen; nur Inhaber und Admins bestätigen Änderungen.',
      nobody: 'Der Assistent antwortet und berät, ändert aber nichts. Funktionswünsche werden weiterhin gesendet.',
    },
    policyMember: {
      everyone: 'Sie können vom Assistenten vorbereitete Änderungen im Rahmen Ihrer Rechte bestätigen.',
      admins: 'In diesem Workspace nehmen nur Inhaber und Admins Änderungen über den Assistenten vor. Fragen können Sie weiterhin stellen.',
      nobody: 'Dieser Workspace hat Änderungen über den Assistenten ausgeschaltet. Fragen können Sie weiterhin stellen.',
    },
    saving: 'Wird gespeichert…',
    saveFailed: 'Die Einstellung konnte nicht gespeichert werden.',
    loadFailed: 'Die Assistent-Aktivität konnte nicht geladen werden.',
    refresh: 'Aktualisieren',
    count_one: '{{count}} Änderung',
    count_other: '{{count}} Änderungen',
    empty: 'Noch keine Änderungen über den Assistenten.',
    status: {
      executed: 'Erledigt',
      failed: 'Fehlgeschlagen',
      undone: 'Rückgängig gemacht',
    },
    byYou: 'von Ihnen',
    byPerson: 'von {{name}}',
  },
};
